import { useState, useCallback } from "react";
import {
  setUserPhotoOnBehalf,
  setContactPhotoOnBehalf,
} from "../services/userPhotoService";

/**
 * Mutation hook for uploading a user's profile photo via the
 * setUserPhotoOnBehalf callable.
 */
export function useSetUserPhoto() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const upload = useCallback(
    async (eventId: string, userId: string, file: File) => {
      setLoading(true);
      setError(null);
      try {
        return await setUserPhotoOnBehalf(eventId, userId, file);
      } catch (err) {
        const e =
          err instanceof Error ? err : new Error("Set user photo failed");
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { upload, loading, error };
}

/**
 * Mutation hook for uploading a contact's profile photo via the
 * setUserPhotoOnBehalf callable (contactId mode).
 */
export function useSetContactPhoto() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const upload = useCallback(async (contactId: string, file: File) => {
    setLoading(true);
    setError(null);
    try {
      return await setContactPhotoOnBehalf(contactId, file);
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Set contact photo failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { upload, loading, error };
}
